import React from 'react'
import styled from 'styled-components'

interface PillProps {
    label: string
    onClick: () => void
    selected?: boolean
    key?: string
}

function Pill({ label, onClick, selected = false, key }: PillProps) {
    return (
        <PillComponent onClick={() => onClick()} selected={selected} key={key}>
            {label}
        </PillComponent>
    )
}

interface PillComponentProps {
    selected: boolean
}

const PillComponent = styled.label<PillComponentProps>`
    border-radius: 77px;
    background: ${({ selected }) => (selected ? 'var(--blue-500)' : 'var(--gray-800)')};
    color: ${({ selected }) => (selected ? 'white' : 'var(--gray-300)')};
    padding: 4px 8px;
    font-size: 14px;
    line-height: 16px;
    font-weight: 600;
    display: inline-block;
    margin: 4px;
    height: 26px;
    transition: all 0.2s;
    cursor: pointer;
`

export { Pill }
